<template>
  <div class="device-item" id="deviceForm">
    <button class="btn-remove" title="Remover" v-on:click="removeRow(device)">
      <span class="material-icons"> delete_forever </span>
    </button>
    <div class="loader-content" v-if="isLoading">
      <Loader />
    </div>
    <div class="header-content">
      <label class="legend">{{ device.deviceName }}</label>
    </div>
    <div class="body-content">
      <div class="token-details" v-if="device.token">
        <h5 class="title">Token/Licencia:</h5>
        <div
            class="alert-container"
            title="Haga click para copiar al portapapeles"
            @click="copyToken"
        >
          <div class="body">
            <div class="token-content">
              {{ device.token }}
            </div>
            <input type="hidden" id="tokenText" v-model="device.token" />
          </div>
        </div>
      </div>
      <div class="grid-columns">
        <div class="column mt-2">
          <CompanySelector v-model="company" />
        </div>
        <div class="column">
          <b-field label="Tipo de dispositivo *">
            <b-select
                :placeholder="$t('device.deviceTypePlaceholder')"
                name="deviceType"
                v-model="device.deviceType"
                expanded
            >
              <option
                v-for="option in Array.isArray(deviceTypes) &&
                deviceTypes.length > 0
                  ? deviceTypes
                  : device.deviceTypes"
                :value="option.code"
                :key="option.code"
                :id="option.code"
              >
                {{ option.title }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Nombre de dispositivo  *">
            <b-input
                placeholder="Nombre de dispositivo"
                type="text"
                name="deviceName"
                v-model="device.deviceName"
            />
          </b-field>
        </div>
        <div class="column">
          <b-field label="Estado *">
            <b-select
                placeholder="Estado"
                expanded
                v-model="device.status"
                name="status"
            >
              <option
                v-for="option in device.statusList"
                :value="option.code"
                :key="option.code"
                :id="option.code"
              >
                {{ $t(option.description) }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Nickname *">
            <b-input
              placeholder="Nickname"
              type="text"
              name="nickname"
              v-model="device.nickname"
            />
          </b-field>
        </div>
        <div class="column">
          <b-field label="Serial">
            <b-input
              placeholder="Serial"
              type="text"
              name="serial"
              v-model="device.serial"
              @input="onSerialInput"
            />
          </b-field>
        </div>
        <div
          v-for="(field, index) in device.dinamycFields"
          :key="field.key"
          :id="field.key"
          class="column"
          :class="field.hide ? 'hide' : ''"
          :style="getColumnStyle(field)"
          v-if="!field.hide"
        >
          <DinamycField
            v-bind:field="field"
            v-bind:index="index"
            v-bind:dynamicFields="device.dinamycFields"
            v-bind:dinamycValueFields="device.dinamycValueFields"
            v-bind:slot-list="slotList"
            @onChange="onChangeValue"
          />
        </div>
        <div class="column mt-button">
          <vs-button
            color="primary"
            class="pl-5 pr-5"
            icon="add"
            type="filled"
            v-on:click="addSubItem(device)"
            :disabled="validate(device)"
          >
            Agregar
          </vs-button>
        </div>
      </div>
      <div
        class="subdevices-content mt-3"
        v-if="Array.isArray(device.devices) && device.devices.length"
      >
        <b-table :data="device.devices">
          <b-table-column
              field="status"
              label="Tipo dispositivo"
              v-slot="props"
          >
            {{ parseDeviceType(props.row.deviceType) }}
          </b-table-column>
          <b-table-column field="status" label="Estado" v-slot="props">
            {{ parseStatus(props.row.status) }}
          </b-table-column>
          <b-table-column field="title" label="Nombre" v-slot="props">
            <div class="flex name-options-table">
              <span class="label-title">
                {{ props.row.deviceName }}
              </span>
              <div class="options flex">
                <button
                    class="btn remove"
                    v-on:click="removeRow(props.row)"
                    title="Eliminar"
                >
                  <span class="material-icons"> delete_forever </span>
                </button>
                <button
                    class="btn primary edit"
                    v-on:click="editRow(props.row)"
                    title="Editar"
                >
                  <span class="material-icons"> edit </span>
                </button>
              </div>
            </div>
          </b-table-column>
          <template #empty>
            <div class="has-text-centered">Sin registros</div>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>
<script>
import { ROUTES } from '@/global/api_routes'
import { validator } from '@/global/validator'
import Loader from '../../../components/Shared/Loader.vue'
import DeviceItemForm from './SubDeviceForm.vue'
import { DETAILS_STATUS } from '@/global/constants'
import DinamycField from './DinamycField.vue'
import { confirmation } from '@/global/utils'
import { configToast, TOAST_TYPES } from '@/global/toast'
import CompanySelector from '../../../components/Shared/CompanySelector'

export default {
  components: { Loader, DeviceItemForm, DinamycField, CompanySelector },
  props: {
    onChangeCompany: {
      type: Function,
      default: (company) => {
        console.log('changeCompany', company)
      },
    },
    device: {
      type: Object,
      default: {},
    },
    deviceTypes: {
      type: Array,
      default: [],
    },
    slotList: {
      type: Array,
      default: [],
    },
  },
  data: () => ({
    isLoading: false,
    company: null,
  }),
  mounted() {
    this.company = this.device.company
    console.log(this.device)
  },
  watch: {
    'device.deviceType': function (id) {
      if (!id) {
        return
      }
      this.getDeviceTypesFields(id)
    },
  },
  methods: {
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, '#deviceForm')
      return instance.open(message, type)
    },
    // FIX:: REVISAR ESTO:
    // onChangeCompanyFn(company) {
    //   console.log("COMPANY", company);
    //   this.company = company.code;
    //   this.$emit("onChangeCompany", { company, device: this.device });
    // },
    onChangeValue(change) {
      const obj = { ...this.device.dinamycValueFields }
      obj[change.key] = change.value
      this.device.dinamycValueFields = obj
    },
    getColumnStyle(field) {
      return field.fullWidth ? { 'grid-column': '1 / -1' } : {}
    },
    onSerialInput(value) {
      this.device.serial = value.replace(/[^a-zA-Z0-9-]/g, '')
    },
    copyToken() {
      let testingCodeToCopy = document.querySelector('#tokenText')
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()

      try {
        var successful = document.execCommand('copy')
        var msg = successful
            ? "Copiado al portapapeles correctamente"
            : "No se pudo copiar";
        this.toast(msg, TOAST_TYPES.SUCCESS);
      } catch (err) {
        this.toast(this.$t('device.deviceConfigurationError') + msg, TOAST_TYPES.ERROR);
      }
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    editRow(row) {
      this.$emit('editDevice', row)
    },
    removeRow(row) {
      confirmation(this, '¿Deseas eliminar este dispositivo?').then(
        (result) => {
          if (!result) {
            return
          }
          this.$emit('deleteDevice', row)
        }
      )
    },
    parseDeviceType(type) {
      const deviceType = this.device.deviceTypes.find(
        (deviceType) => deviceType.code === type
      )
      return deviceType ? deviceType.title : 'No definido'
    },
    parseStatus(status) {
      return DETAILS_STATUS[status] ? DETAILS_STATUS[status].description : 'N/A'
    },
    addSubItem(device) {
      this.$emit('addDeviceSubitem', device)
    },
    validate(device) {
      const rules = [
        { field: 'deviceType' },
        { field: 'company' },
        { field: 'deviceName' },
        { field: 'status' },
      ]
      const extraValues = {}
      device.dinamycFields.forEach((field, index) => {
        if (field.required) {
          rules.push({ field: field.key })
          extraValues[field.key] = device.dinamycValueFields[field.key]
        }
      })
      const { result, errors } = validator({ ...device, ...extraValues }, rules)
      return !result
    },
    getDeviceTypesFields(id) {
      this.isLoading = true
      this.dinamycFields = []
      this.dinamycValueFields = {}
      this.$http
        .get(ROUTES.DASHBOARD.CONFIG_DEVICES.GET_DEVICE_TYPE_FIELDS, {
          params: {
            deviceTypeId: id,
          },
        })
        .then(({ data }) => {
          if (data.code < 1 || !data.info) {
            this.device.dinamycFields = []
            this.device.dinamycValueFields = []
            return
          }
          this.device.dinamycFields = JSON.parse(data.info.fields)
          this.device.dinamycFields.forEach((field) => {
            this.dinamycValueFields[field.key] = null
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>

<style>
.grid-columns {
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}

.device-item {
  position: relative;
}

.device-item .btn-remove {
  position: absolute;
  right: 0;
  border: none;
  background-color: #f42d51;
  color: #ffffff;
  box-shadow: 0 1px 1px #801125;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.device-item .loader-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffffbf;
  z-index: 5;
}

.subdevices-content {
  background-color: #efefef;
  padding: 10px;
  border-radius: 5px;
}

.name-options-table {
  display: flex;
  width: 100%;
}

.name-options-table .options {
  margin-left: auto;
}

.name-options-table .options .btn {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  background-color: #efefef;
  display: flex;
  padding: 0;
  outline: none;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  transition: all 1ms ease;
}

.name-options-table .options .btn span {
  font-size: 1.5em;
}

.name-options-table .options .btn:last-child {
  margin-right: 0;
}

.name-options-table .options .btn.primary {
  background-color: #1d76fb;
  color: #ffffff;
}

.name-options-table .options .btn:active {
  background-color: black;
  color: #ffffff;
}

.alert-container {
  background-color: #91d18b;
  padding: 14px;
  border-radius: 10px;
}

.alert-container p {
  margin: 0;
}

.alert-container h4 {
  font-size: 0.9em;
}

.token-content {
  display: flex;
  flex-direction: row;
  font-size: 0.8em;
  word-break: break-all;
  cursor: pointer;
}

.token-details:hover .alert-container {
  box-shadow: 1px 1px 3px #000;
}

.alert-container .code-content {
  display: block;
  width: 100%;
  padding: 15px;
  border-radius: 5px;
  color: #222222;
}

.token-details {
  margin-bottom: 15px;
}

.token-details .title {
  font-size: 0.9em;
  margin: 0;
  margin-bottom: 10px;
}
</style>
